// extracted by mini-css-extract-plugin
export default {"form":"EditForm_form__GZMPR","formSectionTitle":"EditForm_formSectionTitle__SiQNe","formActions":"EditForm_formActions__1tqUF"};